module.exports = __webpack_public_path__ + "@/assets/img/todotranquilo.ab28f080.svg";